module.exports = __webpack_public_path__ + "img/minus_btn.4cbc3d55.png";